import React from 'react';
import cn from 'classnames/bind';
import { Breadcrumbs } from '@consta/uikit/Breadcrumbs';
import { useHistory } from 'react-router-dom';

// Styles
import styles from './styles.styl';
const cx = cn.bind(styles);

export interface BreadProps {
  breads: {
    name: string;
    pathname: string;
    isActive?: boolean;
    isProps?: boolean;
  }[];
  className?: string;
  setLinkProps?: (item: boolean) => void;
}

export const Bread: React.FC<BreadProps> = ({
  breads,
  setLinkProps,
  className,
}) => {
  const history = useHistory();
  const newBreads = breads.map(({ name, ...row }, idx) => ({
    id: idx,
    name: <span className={cx('Bread__text')}>{name}</span>,
    ...row,
  }));
  return (
    <div className={cx('Bread', className)}>
      <Breadcrumbs
        className={cx('Bread__crumbs')}
        pages={newBreads}
        size={'s'}
        getLabel={(bread) => bread.name}
        getIsActive={(bread) => !!bread.isActive}
        getLink={(bread) => bread.pathname}
        onClick={(bread, e) => {
          e.preventDefault();
          bread?.isProps ? setLinkProps(false) : history.push(bread.pathname);
        }}
      />
    </div>
  );
};
